import { HTMLAttributes, ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title?: string;
  className?: string;
  childrenClassName?: string;
} & HTMLAttributes<HTMLHeadingElement>;

export default function IconicTitle({
  icon,
  className = "",
  childrenClassName = "",
  title = "",
  ...rest
}: Props) {
  return (
    <h3
      {...rest}
      className={`text-[16px] font-medium leading-7 flex items-center gap-3 ${className}`}
    >
      {icon}{" "}
      <span className={`relative top-[1px] ${childrenClassName}`}>{title}</span>
    </h3>
  );
}
